/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * @file OnboardingManualSetupIcon.jsx
 * Manual setup action icon.
 * @author Anuja Gaikwad
 * @version 2.0.3
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropTypes from 'prop-types';

const OnboardingManualSetupIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path d="M29.492 16.5161H18.544C18.26 16.5161 18.024 16.7481 18.024 17.0361C18.024 17.3241 18.256 17.5561 18.544 17.5561H29.492C29.776 17.5561 30.012 17.3241 30.012 17.0361C30.012 16.7481 29.78 16.5161 29.492 16.5161Z" fill="currentColor" />
    <path d="M29.492 22.4441H18.544C18.26 22.4441 18.024 22.6761 18.024 22.9641C18.024 23.2521 18.256 23.4841 18.544 23.4841H29.492C29.776 23.4841 30.012 23.2521 30.012 22.9641C30.012 22.6761 29.78 22.4441 29.492 22.4441Z" fill="currentColor" />
    <path d="M29.844 10.4919H10.156C7.864 10.4919 6 12.3559 6 14.6479V25.3479C6 27.6399 7.864 29.5039 10.156 29.5039H29.84C32.132 29.5039 33.996 27.6399 33.996 25.3479V14.6479C33.996 12.3559 32.132 10.4919 29.84 10.4919H29.844ZM13.98 24.7039C14.184 24.9079 14.184 25.2399 13.98 25.4439C13.88 25.5439 13.748 25.5959 13.608 25.5959C13.468 25.5959 13.336 25.5399 13.236 25.4439L11.528 23.7359L9.82 25.4439C9.72 25.5439 9.588 25.5959 9.448 25.5959C9.308 25.5959 9.176 25.5399 9.076 25.4439C8.872 25.2399 8.872 24.9079 9.076 24.7039L10.784 22.9959L9.076 21.2879C8.872 21.0839 8.872 20.7519 9.076 20.5479C9.28 20.3439 9.612 20.3439 9.816 20.5479L11.524 22.2559L13.232 20.5479C13.436 20.3439 13.768 20.3439 13.972 20.5479C14.176 20.7519 14.176 21.0839 13.972 21.2879L12.264 22.9959L13.972 24.7039H13.98ZM14 14.5679L11.192 17.3759C11.092 17.4759 10.96 17.5279 10.82 17.5279C10.68 17.5279 10.548 17.4719 10.448 17.3759L9.06 15.9879C8.96 15.8879 8.908 15.7559 8.908 15.6159C8.908 15.4759 8.964 15.3439 9.06 15.2439C9.264 15.0399 9.596 15.0399 9.8 15.2439L10.82 16.2639L13.256 13.8279C13.456 13.6279 13.8 13.6319 13.996 13.8279C14.2 14.0319 14.2 14.3639 13.996 14.5679H14ZM32.952 25.3479C32.952 27.0639 31.556 28.4599 29.84 28.4599H15.972V11.5359H29.84C31.556 11.5359 32.952 12.9319 32.952 14.6479V25.3479Z" fill="currentColor" />

  </SvgIcon>
);

OnboardingManualSetupIcon.propTypes = {
  className: PropTypes.string
};

OnboardingManualSetupIcon.defaultProps = {
  className: ''
};

export default OnboardingManualSetupIcon;
